<template>
  <button
    type="button"
    class="flex aspect-square items-center justify-center rounded-full bg-primary text-xs font-semibold text-white active:opacity-60"
    v-bind="$attrs"
    :style="{
      backgroundColor: currentCashier?.color ?? undefined,
    }"
    @click="cashierSwitchDialogRef?.reveal()"
  >
    <template v-if="cashierInitials">
      {{ cashierInitials }}
    </template>
    <IconChangeCashier v-else class="size-3.5 text-white" />
  </button>

  <CashierSwitchDialog ref="cashierSwitchDialogRef" />
</template>

<script setup lang="ts">
import { IconChangeCashier } from "@/icons"
import { useCashiers } from "@/services/cashiers/listCashiers"

defineOptions({
  inheritAttrs: false,
})

const { cashierId } = useAuth()
const { getById: getCashierById } = useCashiers()

const cashierSwitchDialogRef = useTemplateRef(
  "cashierSwitchDialogRef"
)

const currentCashier = computed(
  () => getCashierById(cashierId).value
)

const cashierInitials = computed(() => {
  if (currentCashier.value === undefined) return null
  return buildShortString(currentCashier.value.username)
})
</script>
